import { ExamId, Workflow } from '@parsys/frontend_library';

export const getPreConsultationOriginsForWorkflow = (workflow: Workflow) => {
  const transitions = workflow?.transitions;
  if (!transitions) {
    return [];
  }
  return Object.keys(transitions).reduce<ExamId[]>((acc, transition) => {
    transitions[transition].exams_full.forEach((exam) => {
      if (exam.preConsultationOrigin) {
        acc.push(exam.id);
      }
    });
    return acc;
  }, []);
};
